import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const validateEmail: (email: string) => boolean = (email) => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateEmailAddresses: (
  data: string[][],
  emailColName: string
) => number[] = (data, emailColName) => {
  const emailIndex: number = data[0].indexOf(emailColName);
  const invalidEmailRows: number[] = [];
  data.forEach((row, rowIndex) => {
    // don't validate header row and only validate if there is a value
    if (rowIndex && row[emailIndex] && !validateEmail(row[emailIndex])) {
      invalidEmailRows.push(rowIndex);
    }
  });
  return invalidEmailRows;
};

export const countEmailRows: (
  data: string[][],
  emailColName: string
) => number = (data, emailColName) => {
  const emailIndex: number = data[0].indexOf(emailColName);
  return data.filter((row, rowIndex) => rowIndex && row[emailIndex]).length;
};

export const validatePhoneNumber: (phoneNumber: string) => boolean = (
  phoneNumber
) => {
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, "FR");
    return (
      phoneUtil.isPossibleNumber(number) && phoneUtil.isValidNumber(number)
    );
  } catch (e) {
    return false;
  }
};

export const validatePhoneNumbers: (
  data: string[][],
  phoneNumberColName: string
) => number[] = (data, phoneNumberColName) => {
  const phoneNumberIndex: number = data[0].indexOf(phoneNumberColName);
  const invalidPhoneNumberRows: number[] = [];
  data.forEach((row, rowIndex) => {
    // don't validate header row and only validate if there is a value
    if (
      rowIndex &&
      row[phoneNumberIndex] &&
      !validatePhoneNumber(row[phoneNumberIndex])
    ) {
      invalidPhoneNumberRows.push(rowIndex);
    }
  });
  return invalidPhoneNumberRows;
};

export const formatPhoneNumber: (phoneNumber: string) => string = (
  phoneNumber
) => {
  const number = phoneUtil.parseAndKeepRawInput(phoneNumber, "FR");
  return phoneUtil.format(number, PhoneNumberFormat.E164);
};
